var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyLibraryWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 211,
    viewBox: "0 0 288 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 144,
    cy: 175,
    rx: 110,
    ry: 12,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.3914 66.4428C88.6013 64.7166 79.2655 71.2536 77.5392 81.0437L68.1622 134.223C66.436 144.013 72.973 153.349 82.7631 155.076L189.122 173.83C198.912 175.556 208.248 169.019 209.975 159.229L219.352 106.049C221.078 96.2589 214.541 86.9231 204.751 85.1968L98.3914 66.4428Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.139 51.0332C103.907 46.682 108.056 43.7767 112.407 44.5439L199.07 59.825C203.421 60.5922 206.327 64.7415 205.559 69.0926L205.212 71.0622C205.02 72.15 203.983 72.8763 202.895 72.6845L104.414 55.3197C103.327 55.1279 102.6 54.0906 102.792 53.0028L103.139 51.0332Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.034 30.5235C125.801 26.1723 129.95 23.267 134.301 24.0342L185.511 33.0639C189.862 33.8311 192.768 37.9804 192 42.3316L191.653 44.3012C191.461 45.389 190.424 46.1153 189.336 45.9235L126.309 34.81C125.221 34.6182 124.494 33.5809 124.686 32.4931L125.034 30.5235Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.3914 66.4428C88.6013 64.7166 79.2655 71.2536 77.5392 81.0437L68.1622 134.223C66.436 144.013 72.973 153.349 82.7631 155.076L189.122 173.83C198.912 175.556 208.248 169.019 209.975 159.229L219.352 106.049C221.078 96.2589 214.541 86.9231 204.751 85.1968L98.3914 66.4428Z",
    stroke: "#BDBAB4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.139 51.0332C103.907 46.682 108.056 43.7767 112.407 44.5439L199.07 59.825C203.421 60.5922 206.327 64.7415 205.559 69.0926L205.212 71.0622C205.02 72.15 203.983 72.8763 202.895 72.6845L104.414 55.3197C103.327 55.1279 102.6 54.0906 102.792 53.0028L103.139 51.0332Z",
    stroke: "#BDBAB4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.034 30.5235C125.801 26.1723 129.95 23.267 134.301 24.0342L185.511 33.0639C189.862 33.8311 192.768 37.9804 192 42.3316L191.653 44.3012C191.461 45.389 190.424 46.1153 189.336 45.9235L126.309 34.81C125.221 34.6182 124.494 33.5809 124.686 32.4931L125.034 30.5235Z",
    stroke: "#BDBAB4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.179 130.738C127.792 132.935 129.852 134.771 131.989 134.135L160.164 125.754C162.534 125.049 163.082 121.942 161.096 120.469L137.487 102.957C135.695 101.629 133.132 102.65 132.745 104.846L128.179 130.738Z",
    fill: "#F2F2F2",
    stroke: "#BDBAB4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyLibraryWhite);
export default __webpack_public_path__ + "static/media/empty-library-white.f69c545a2ac9c18b6572b54291f37a56.svg";
export { ForwardRef as ReactComponent };